import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import styles from "./TermsOfUse.module.css";

const TermsOfUse = () => {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.headerSection}>
        <h1 className={styles.mainTitle}>Terms of Use</h1>
      </div>

      <div className={styles.contentSection}>
        <ol className={styles.orderedList}>
          <li className={styles.listItem}>
            The terms of use set out below, together with our privacy policy,
            apply to the entire contents of business.engie.co.uk,
            myquote-business.engie.co.uk and any subsidiary ENGIE sites which
            are linked to such site (together, the 'Website'). Your use of the
            Website indicates your acceptance of these terms and conditions.
            Please read them carefully before proceeding.
          </li>

          <li className={styles.listItem}>
            The term ENGIE or "us" or "we" refers to any subsidiary of ENGIE SA
            which is incorporated and operates in the United Kingdom.
          </li>

          <li className={styles.listItem}>
            The terms and conditions of this Website may be updated or amended
            from time to time without prior notice.
          </li>

          <li className={styles.listItem}>
            ENGIE endeavours to ensure that the information contained within the
            Website is up to date, correct and complete. In the event of
            inadvertent or occasional errors ENGIE accepts no liability.
            Further, ENGIE cannot accept any liability for loss of any kind
            resulting from reliance on the information or opinions provided
            within the Website nor from any computer viruses and other malicious
            programs on the Website despite ENGIE's reasonable precautions
            against them.
          </li>

          <li className={styles.listItem}>
            ENGIE intends to make the Website available 24 hours a day but
            cannot be held liable for any non-availability or error regardless
            of whether the circumstances are inside or outside ENGIE's control
          </li>

          <li className={styles.listItem}>
            This Website contains links to external websites to allow access to
            additional information about related matters. ENGIE accepts no
            responsibility or liability for material supplied by or contained on
            any external website which is linked from or to this Website, or use
            of any personal data by a third party.
          </li>

          <li className={styles.listItem}>
            The copyright and all other intellectual property rights, including
            logos, trademarks and brand names, in the material on this Website
            are owned by or licensed to ENGIE. Forms and market reports may be
            downloaded to a local hard disk for your personal and internal
            business use. Any other reproduction or use of extracts from the
            Website incorporated into or stored in any form for any purpose is
            prohibited without the written or express permission of ENGIE.
          </li>

          <li className={styles.listItem}>
            When you visit the Website, our web server collects some basic
            information such as your internet service provider's domain name,
            which pages you accessed on our site, and when. We use this
            information only to analyse the use of our Website to help guide
            improvements. We do not collect any personally identifiable
            information
          </li>

          <li className={styles.listItem}>
            When you visit the Website, we use cookies, which are small pieces
            of information that allow us to maintain your connection to the
            Website. The Website may use cookies for detecting what kind of
            device you have in order to present content in the best way, for a
            language switch and/or for other purposes. These cookies do not
            collect or store any personally identifiable information. You may
            refuse to accept cookies by activating the setting on your browser
            which allows you to refuse the setting of cookies. However, if you
            select this setting you may be unable to access certain parts of our
            Website. If you have adjusted your browser setting so that it will
            refuse cookies, our system will issue cookies when you log on to our
            Website.
          </li>

          <li className={styles.listItem}>
            The Website uses Matomo Analytics, a web analytics service provided
            by Matomo. Matomo Analytics uses cookies (text files placed on your
            computer) to help the website operators analyse how users use the
            site. The information generated by the cookie about your use of the
            Website (including your IP address) will be transmitted to and
            stored by Matomo on servers in the EU. Matomo will use this
            information for the purpose of evaluating your use of the Website,
            compiling reports on website activity for website operators and
            providing other services relating to website activity and internet
            usage. Matomo may also transfer this information to third parties
            where required to do so by law, or where such third parties process
            the information on Matomo's behalf. Matomo will not associate your
            IP address with any other data held by Matomo for any reason. By
            using the Website, you consent to the processing of data about you
            by Matomo in the manner and for the purposes set out above.
          </li>

          <li className={styles.listItem}>
            Specific terms pertaining to the Portal:
            <p className={styles.paragraph}>
              For the purposes of this clause 11, the words defined shall have
              the following meanings;
            </p>
            <p className={styles.paragraph}>
              "Acknowledgement" means an e-mail generated by ENGIE that
              acknowledges receipt of an Application from an Applicant;
            </p>
            <p className={styles.paragraph}>
              "Applicant" means a party representing a non domestic business
              submitting a Request and Application, as applicable, through the
              Portal;
            </p>
            <p className={styles.paragraph}>
              "Application" means an application to enter into a Supply
              Contract;
            </p>
            <p className={styles.paragraph}>
              "Portal" means myquote-business.engie.co.uk section of the
              Website;
            </p>
            <p className={styles.paragraph}>
              "Quotation" means ENGIE's response to a Request;
            </p>
            <p className={styles.paragraph}>
              "Request" means a submission by an Applicant to receive a
              Quotation from ENGIE for the supply of gas and/or electricity to
              an Applicant's business submitted through the Portal;
            </p>
            <p className={styles.paragraph}>
              "Supply Contact" means a contract between ENGIE and an Applicant
              for ENGIE to supply gas or electricity to the Applicant's business
              and incorporating the Supply Contract Terms and Conditions and the
              Application accepted by ENGIE
            </p>
            <p className={styles.paragraph}>
              "Supply Contract Terms and Conditions" shall mean the terms of
              conditions for the supply of gas and electricity respectively made
              available in portable document format ({" "}
              <strong className={styles.strong}>PDF</strong> ) in the Portal;
            </p>
            <ol className={styles.nestedList}>
              <li className={styles.listItem}>
                Any Quotation, both in the case of gas and electricity, is based
                solely on the consumption data provided by an Applicant at the
                time of the Application and the price detailed in a Quotation
                may change due to price fluctuation and/or other market forces
                should the Applicant's estimated or actual consumption
                subsequently differ.
              </li>

              <li className={styles.listItem}>
                Submission of a Request, generation of a Quotation, submission
                of an Application and/or delivery of an Acknowledgement shall
                not constitute or be deemed to comprise a binding contract or
                arrangement between ENGIE and the Applicant.
              </li>

              <li className={styles.listItem}>
                Subject to the terms of clause 11.4, a binding contract between
                the ENGIE and the Applicant shall only take effect once a credit
                eligibility check has been completed on the Applicant's business
                to ENGIE's satisfaction and ENGIE have confirmed to the
                Applicant in writing by e-mail that the Application has been
                accepted by ENGIE.
              </li>

              <li className={styles.listItem}>
                ENGIE is under no obligation to accept any Application for the
                supply of gas and/or electricity made by any Applicant through
                the Portal.
              </li>

              <li className={styles.listItem}>
                The Portal is intended for use by SME businesses and therefore
                any Applications made by domestic users and/or third party
                intermediaries or any other entity deemed ineligible by ENGIE in
                its sole discretion shall be rejected, and in no circumstances
                shall ENGIE be liable to pay any commission or other payment or
                benefit to any party as a consequence of an Application and/or
                completion of any Supply Contract.
              </li>

              <li className={styles.listItem}>
                Calls to 0800 numbers are free. Calls may be monitored or
                recorded for quality assurance or training purposes.
              </li>
            </ol>
          </li>
        </ol>

        <ol start="12" className={styles.finalList}>
          <li>
            Use of the Website and any dispute arising therefrom is subject to
            the laws of England, Northern Ireland, Scotland and Wales.
          </li>
        </ol>
      </div>

      <Footer showAccordions={false} />
    </div>
  );
};

export default TermsOfUse;
